export const CommonStyle = {
    container: (baseStyles) => ({
        ...baseStyles,
        flex: "1 1 auto",
        minWidth: 0,
    }),
    control: (baseStyles, state) => ({
        ...baseStyles,
        borderColor: state.isFocused ? "#80bdff" : "#ced4da",
        boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)" : "none",
        height: "32px",
        minHeight: "32px",
        maxHeight: "32px",
        fontSize: "14px",
        padding: 0,
        alignItems: "center",
    }),
    valueContainer: (baseStyles) => ({
        ...baseStyles,
        padding: "0 8px",
        alignItems: "center",
    }),
    singleValue: (baseStyles) => ({
        ...baseStyles,
        fontSize: "14px",
        lineHeight: "20px",
    }),
    placeholder: (baseStyles) => ({
        ...baseStyles,
        fontSize: "14px",
        lineHeight: "20px",
    }),
    input: (baseStyles) => ({
        ...baseStyles,
        fontSize: "14px",
        lineHeight: "20px",
        margin: 0,
        padding: 0,
    }),
    option: (baseStyles) => ({
        ...baseStyles,
        fontSize: "14px",
    }),
    clearIndicator: (baseStyles) => ({
        ...baseStyles,
        padding: "4px",
    }),
    dropdownIndicator: (baseStyles) => ({
        ...baseStyles,
        padding: "4px",
    }),
    menuPortal: (baseStyles) => ({
        ...baseStyles,
        zIndex: 9999,
    }),
}
